/* eslint-disable react/forbid-prop-types */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import './styles.scss';
// import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';

// Import das culturas do datePicker
import ptBR from '../../../node_modules/date-fns/locale/pt-BR';
import enUS from '../../../node_modules/date-fns/locale/en-US';
import es from '../../../node_modules/date-fns/locale/es';
import nlBE from '../../../node_modules/date-fns/locale/nl-BE';
// ? Outras linguagens que ainda não estão liberadas
// import deDE from '../../../node_modules/date-fns/locale/de-DE';
// import en from '../../../node_modules/date-fns/locale/en';
// import esCL from '../../../node_modules/date-fns/locale/es-CL';
// import esCO from '../../../node_modules/date-fns/locale/es-CO';
// import esUY from '../../../node_modules/date-fns/locale/es-UY';
// import frBE from '../../../node_modules/date-fns/locale/fr-BE';
// import frFR from '../../../node_modules/date-fns/locale/fr-FR';
// import ptPT from '../../../node_modules/date-fns/locale/pt-PT';
// import zhMO from '../../../node_modules/date-fns/locale/zh-MO';

registerLocale('pt-BR', ptBR);
registerLocale('en-US', enUS);
registerLocale('es', es);
registerLocale('nl-BE', nlBE);
// ? Outras linguagens que ainda não estão liberadas
// registerLocale('de-DE', deDE);
// registerLocale('en', en);
// registerLocale('es-CL', esCL);
// registerLocale('en-CO', esCO);
// registerLocale('en-UY', esUY);
// registerLocale('fr-BE', frBE);
// registerLocale('fr-FR', frFR);
// registerLocale('pt-PT', ptPT);
// registerLocale('zh-MO', zhMO);

const EpFormDate = ({
  labelText, onChange, dateId, placeholderText, selected, nameDate,
  classError, autoComplete, maxDate, selectsStart, selectsEnd, startDate, endDate, minDate,
  // const currentUserLanguage = useSelector(state => state.globalization.language);
}) =>
  (
    <>
      <label htmlFor={dateId} className="form-label">{labelText}</label>
      <DatePicker
        locale="pt-BR"
        dateFormat="P"
        startDate={Date.parse(startDate)}
        endDate={Date.parse(endDate)}
        selectsEnd={!!selectsEnd}
        selectsStart={!!selectsStart}
        maxDate={Date.parse(maxDate)}
        minDate={Date.parse(minDate)}
        name={nameDate}
        id={dateId}
        selected={Date.parse(selected)}
        onChange={val => onChange(val)}
        placeholderText={placeholderText}
        className={`form-control ${classError}`}
        autoComplete={autoComplete}
        popperPlacement="top-end"
      />
    </>
  );
export default EpFormDate;

EpFormDate.defaultProps = {
  placeholderText: null,
  selected: null,
  selectsStart: false,
  selectsEnd: false,
  endDate: null,
  startDate: null,
};

EpFormDate.propTypes = {
  selected: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.string.isRequired,
  dateId: PropTypes.string.isRequired,
  placeholderText: PropTypes.string,
  maxDate: PropTypes.any.isRequired,
  minDate: PropTypes.any.isRequired,
  nameDate: PropTypes.string.isRequired,
  classError: PropTypes.string.isRequired,
  autoComplete: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  endDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  selectsStart: PropTypes.bool,
  selectsEnd: PropTypes.bool,
};
